import React, { createContext, useContext } from 'react';
import { get } from 'lodash';

const TranslationContext = createContext({ t: (key: string) => key });

export const useTranslation = () => useContext(TranslationContext);

export const TranslationProvider = ({ children, labels }) => {
  const t = (key?: string) => {
    if (!key) {
      return labels;
    }
    return get(labels, key, key);
  };

  return <TranslationContext.Provider value={{ t }}>{children}</TranslationContext.Provider>;
};
